import service from "./service"

// Best-effort tracking of how far the candidate got through the form. Fired as the
// candidate lands on each page; failures are intentionally swallowed so this can never
// disrupt the form.
const trackPreCheckFormProgress = async (data) => {
    try {
        return await service(data)
    }
    catch {
        return null
    }
}

export default trackPreCheckFormProgress
